import { Fragment } from 'react';
import MojitoCore from 'mojito/core';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';

const classUtils = MojitoCore.Base.classUtils;
const DELIMITER = ':';

export default function FixedWidthTime(props) {
    const {
        mojitoTools: { config },
        time,
    } = props;

    const renderTimePart = (digits, index) => {
        return (
            <Fragment key={index}>
                {[...digits].map((digit, digitIndex) => (
                    <Text
                        class={`ta-time-${index}-${digitIndex}`}
                        config={config.timePart}
                        key={`${index}-${digitIndex}`} // eslint-disable-line react/no-array-index-key
                    >
                        {digit}
                    </Text>
                ))}
            </Fragment>
        );
    };

    const className = classUtils.classNames('ta-FixedWidthTime', props.class);
    return (
        <FlexPane class={className} separator={() => config.separator} config={config.timeBox}>
            {time.split(DELIMITER).map((part, index) => renderTimePart(part, index))}
        </FlexPane>
    );
}
